import React from "react";
import PropTypes from "prop-types";
import { Col, Row } from "react-bootstrap";
import { BannerContents } from "../shared/layout";
import { Button } from "../shared/actions";

const GenericBanner = ({
  image,
  className,
  title,
  text,
  button,
  titleClassName,
  textClassName
}) => (
  <BannerContents.Banner backgroundImage={image} className={className} left>
    <Row>
      <Col xs={12} md={12} className="ps-md-7 d-flex align-items-stretch">
        <h4 className={`d-md-inline-block ${titleClassName}`}>{title}</h4>
      </Col>
      <Col xs={12} md={12} className="ps-md-7">
        <p className={`text-body-md mt-0 mt-md-2 ${textClassName}`}>{text}</p>
        {button && (
          <Button
            className={`mt-2 ${button.className}`}
            blank
            secondary
            href={button.href}
          >
            {button.text}
          </Button>
        )}
      </Col>
    </Row>
  </BannerContents.Banner>
);

GenericBanner.defaultProps = {
  className: "",
  title: "",
  text: "",
  button: null,
  titleClassName: "",
  textClassName: ""
};

GenericBanner.propTypes = {
  image: PropTypes.string.isRequired,
  className: PropTypes.string,
  title: PropTypes.node,
  text: PropTypes.node,
  button: PropTypes.shape({
    text: PropTypes.string,
    href: PropTypes.string,
    className: PropTypes.string
  }),
  titleClassName: PropTypes.string,
  textClassName: PropTypes.string
};

export default GenericBanner;
